import { render, staticRenderFns } from "./AddPrivilege.vue?vue&type=template&id=8f4259a4&scoped=true"
import script from "./AddPrivilege.vue?vue&type=script&lang=js"
export * from "./AddPrivilege.vue?vue&type=script&lang=js"
import style0 from "./AddPrivilege.vue?vue&type=style&index=0&id=8f4259a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4259a4",
  null
  
)

export default component.exports